[
  {
    "id": "con-coach-001",
    "club_id": "1b296210-fd7d-5202-a17f-657bd97aec7b",
    "group_id": "86ef8e52-5df5-46b0-951b-ae5703fba880",
    "season_id": "season-2026-2027",
    "coach_id": "c1a23456-7890-4abc-def0-123456789001",
    "name": "Ernesto Valverde",
    "image_url": "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&auto=format&fit=crop&q=80",
    "annual_salary": 2400000,
    "signing_bonus": 1200000,
    "release_clause": 10000000,
    "first_round": 1,
    "total_rounds": 38,
    "signed_at": "2026-08-15T10:00:00Z",
    "ends_at": "2027-06-30T23:59:59Z",
    "terminated_at": null,
    "active": true
  },
  {
    "id": "con-coach-002",
    "club_id": "1b296210-fd7d-5202-a17f-657bd97aec7b",
    "group_id": "86ef8e52-5df5-46b0-951b-ae5703fba880",
    "season_id": "season-2025-2026",
    "coach_id": "c2a23456-7890-4abc-def0-123456789002",
    "name": "Marcelino García Toral",
    "image_url": "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&auto=format&fit=crop&q=80",
    "annual_salary": 1800000,
    "signing_bonus": 1000000,
    "release_clause": 5000000,
    "first_round": 1,
    "total_rounds": 38,
    "signed_at": "2025-08-10T09:00:00Z",
    "ends_at": "2026-06-30T23:59:59Z",
    "terminated_at": "2026-08-14T18:00:00Z",
    "active": false
  }
]
